import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "@/components/landing/BrandMark";
import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/lib/contact";

const NAV = [
  { key: "start", href: "/#top" },
  { key: "personalization", href: "/#personalization" },
  { key: "bulk", href: "/#bulk" },
  { key: "reputation", href: "/#reputation" },
  { key: "faq", href: "/#faq" },
  { key: "contact", href: "/#contact" },
  { key: "bestseller", href: "/#bestseller" },
];

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-brand-ink text-white/80 pt-20 pb-10" data-testid="site-footer">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="[&_*]:text-white">
              <BrandMark textClassName="!text-white" markClassName="bg-white/5 border-white/20 text-white" />
            </div>
            <p className="mt-6 max-w-sm text-sm text-white/60 leading-relaxed">
              {t.footer.tagline}
            </p>
            <div className="mt-8 space-y-1.5 text-sm">
              <div>
                <a
                  href={CONTACT.whatsappUrl("")}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-brand-champagne link-underline"
                  data-testid="footer-whatsapp"
                >
                  {CONTACT.whatsappDisplay}
                </a>
              </div>
              <div>
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="text-white/80 hover:text-brand-champagne link-underline"
                  data-testid="footer-email"
                >
                  {CONTACT.email}
                </a>
              </div>
              <div className="text-white/50">{CONTACT.domain}</div>
              <div className="pt-2">
                <a
                  href="https://www.online-bewertungsmanagement.de"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-xs text-white/60 hover:text-brand-champagne transition-colors"
                  data-testid="footer-partner-link"
                >
                  <span className="h-1 w-1 rounded-full bg-brand-champagne" />
                  Schwesterplattform: online-bewertungsmanagement.de
                </a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.22em] font-semibold text-white/50">
              {t.footer.nav}
            </div>
            <ul className="mt-5 grid grid-cols-2 gap-y-2 gap-x-6 text-sm">
              {NAV.map((l) => (
                <li key={l.key}>
                  <a
                    href={l.href}
                    className="text-white/80 hover:text-brand-champagne transition-colors"
                    data-testid={`footer-nav-${l.key}`}
                  >
                    {t.nav[l.key]}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] font-semibold text-white/50">
              {t.footer.legal}
            </div>
            <ul className="mt-5 space-y-2 text-sm">
              <li>
                <Link to="/impressum" className="text-white/80 hover:text-brand-champagne" data-testid="footer-imprint">
                  {t.footer.imprint}
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-white/80 hover:text-brand-champagne" data-testid="footer-privacy">
                  {t.footer.privacy}
                </Link>
              </li>
              <li>
                <Link to="/agb" className="text-white/80 hover:text-brand-champagne" data-testid="footer-terms">
                  {t.footer.terms}
                </Link>
              </li>
              <li>
                <Link to="/datenschutz-email-signatur" className="text-white/80 hover:text-brand-champagne" data-testid="footer-email-privacy">
                  {t.footer.emailPrivacy}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10" data-testid="footer-packaging-notice">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-6">
            <img
              src="/images/seals/verpackungsregister.png"
              alt="Verpackungsregister LUCID — Duales System Interzero"
              className="h-16 w-16 sm:h-20 sm:w-20 shrink-0 rounded-full bg-white/95 p-1.5"
              loading="lazy"
            />
            <div className="text-xs text-white/55 leading-relaxed max-w-xl">
              <p className="text-white/75">
                Registriert im Verpackungsregister LUCID der Stiftung Zentrale
                Stelle Verpackungsregister.
              </p>
              <p className="mt-1.5 tracking-[0.18em] uppercase font-semibold text-white/55">
                Registrierungsnummer: DE5264825059656
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/50">
          <div>
            © {year} in7sekunden. {t.footer.rights}
          </div>
          <div className="tracking-[0.2em] uppercase">NFC · QR · Reputation</div>
        </div>
      </div>
    </footer>
  );
}
